// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { IconBoolean } from '@Atoms/Info/IconBoolean/IconBoolean';
import { useLocalMessage } from '@Helpers/locale';
import { ICONS } from '@Constants/iconsApp';

interface IsIocProps {
    value?: boolean;
    onChange?: (value: boolean) => void;
    readOnly?: boolean;
    onClick?: () => void;
}

export const IsIoc = ({ value, onChange, onClick, readOnly = false }: IsIocProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <IconBoolean
            icon={<ICONS.IocOutline />}
            value={!!value}
            onClick={(): void => {
                onClick?.();
                onChange?.(!value);
            }}
            readOnly={readOnly}
            label={i('common.ioc')}
        />
    );
};
